module.exports = __webpack_public_path__ + "img/no-lists.2e107578.png";